import request from './request'


// // get不传参
// export function getNoParams() {
//     return request.get('/api/...')
// }
// // get传参
// export function getParams(params) {
//     return request.get('/api/...', { params: params })
// }

// 发送短信验证码        
export function basicSendcode(params) {
    return request.post(`/api/basic/sendcode/phone`, params)
}

// 用户登录        
export function basicSignin(params) {
    return request.post(`/api/basic/signin`, params)
}

// 用户注册
export function basicRegister(params) {
    return request.post(`/api/basic/register`, params)
}

// 重置密码 
export function basicPassword(params) {
    return request.put(`/api/basic/password`, params)
}
